import { ref } from 'vue';
import { singleton } from '#shared/singleton';
import { exposeToTests } from '~/utils/exposeToTests';

interface AlertDialog {
  id: number;
  title: string;
  message: string;
  onClose?: () => void;
}

export const useAlertDialog = singleton(() => {
  const dialogs = ref<AlertDialog[]>([]);
  let nextId = 0;

  const showAlert = (title: string, message: string, onClose?: () => void): Promise<void> => {
    return new Promise((resolve) => {
      const id = nextId++;
      const dialog: AlertDialog = { 
        id, 
        title, 
        message, 
        onClose: () => {
          onClose?.();
          resolve();
        }
      };

      dialogs.value.push(dialog);
    });
  };

  const closeAlert = (id: number) => {
    const index = dialogs.value.findIndex(d => d.id === id);
    if (index !== -1) {
      const dialog = dialogs.value[index];
      dialog?.onClose?.();
      dialogs.value.splice(index, 1);
    }
  };

  return {
    dialogs,
    showAlert,
    closeAlert,
    __private: exposeToTests({ 
      get nextId() { return nextId; },
      set nextId(value) { nextId = value; }
    })
  };
});